import { Plus } from "lucide-react";
import Typography from "../Typography/Typography";

export default function RelatedSearch({ text, onClick }) {
  const handleClick = () => {
    onClick(text);
  };

  return (
    <button
      type="button"
      onClick={onClick}
      className="flex items-center justify-between gap-2 w-full pb-4 border-b border-gray-200 hover:bg-gray-50"
    >
      <Typography family="sans" size="16" weight="rg">
        {text}
      </Typography>
      <Plus size={20} />
    </button>
  );
}
